import React from 'react';
import TextareaAutosize from 'react-autosize-textarea';
import Console from '../../../lib/debug';

export default class TextArea extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value || ''
        };
    }
    componentWillReceiveProps(newProps) {
        let textareaHeight = parseInt(
            this.node.textarea.style.height.replace('px', '')
        );
        if (!textareaHeight) {
            textareaHeight = 50;
        }
        if (
            this.props.style &&
            this.props.style.minHeight &&
            textareaHeight > this.props.style.minHeight
        ) {
            newProps.style.minHeight = textareaHeight;
        }
        if (this.props.style && this.props.value === newProps.value) {
            newProps.style.minHeight = textareaHeight;
        }
        this.setState({ value: newProps.value || '' });
    }
    componentDidMount() {
        this.nodeHeight = this.node.textarea.offsetHeight;
    }
    componentDidUpdate() {
        if (
            this.props.onHeightChange &&
            this.node.textarea.offsetHeight !== this.nodeHeight
        ) {
            this.props.onHeightChange(this.node.textarea.offsetHeight);
            this.nodeHeight = this.node.textarea.offsetHeight;
        }
    }
    updateIntent() {
        if (this.props.readonly) {
            this.props.triggerToast();
        }
    }
    updateValue(event) {
        if (this.props.max) {
            if (
                event.target.value.length <= this.props.max ||
                event.nativeEvent.inputType === 'deleteContentBackward'
            ) {
                this.setState({ value: event.target.value });
            }
        } else {
            this.setState({ value: event.target.value });
        }
    }
    focus() {
        if (!this.props.readonly) {
            this.node.textarea.focus();
        }
    }
    handleBlur(event) {
        if (!this.props.readonly) {
            this.props.blurCallback(event);
        }
    }
    handleKeyUp(event) {
        if (!this.props.readonly) {
            this.props.onKeyUp && this.props.onKeyUp(event);
        }
    }

    render() {
        Console.render('designer.TextArea');
        let id = `textarea-${Math.floor(Math.random() * Math.pow(10, 10))}`;
        let placeholder = this.props.placeholder;
        let className = this.props.className;
        let label = this.props.label ? (
            <span className="textarea-label">{this.props.label}</span>
        ) : null;
        let characterCount = this.props.count ? (
            <span className="character-count">
                {this.state.value.length}/{this.props.max}
            </span>
        ) : null;
        className = 'text-area ' + className;

        let disabled = this.props.disabled;

        return (
            <label
                htmlFor={id}
                className="textarea-full"
                onClick={this.updateIntent.bind(this)}
            >
                {label}
                <TextareaAutosize
                    id={id}
                    value={this.state.value}
                    placeholder={placeholder}
                    disabled={disabled}
                    ref={node => {
                        this.node = node;
                    }}
                    onKeyUp={this.handleKeyUp.bind(this)}
                    style={{ ...this.props.style, resize: 'none' }}
                    onChange={this.updateValue.bind(this)}
                    onBlur={this.handleBlur.bind(this)}
                    className={className}
                    readOnly={this.props.readonly}
                />
                {characterCount}
            </label>
        );
    }
}
